'use strict';

var awsIot = require('aws-iot-device-sdk');

const debugMqtt = (client, event) =>
    client.on(event, (error) => {
        dd(`mqtt_${event}`);
        if (error) dd(error);
    });

const connetMqtt = (credentials) => {
    let client = awsIot.device({
        accessKeyId: credentials.accessKeyId,
        secretKey: credentials.secretKey,
        sessionToken: credentials.sessionToken,
        //debug: true,
        clientId: `mqtt-client_${credentials.accessKeyId}_${Date.now()}`,
        protocol: 'wss',
        host: credentials.host,
        //keepalive: 1
    });

    client.on('close', () => client.end());

    debugMqtt(client, 'connect');
    debugMqtt(client, 'reconnect');
    debugMqtt(client, 'close');
    debugMqtt(client, 'disconnect');
    debugMqtt(client, 'offline');
    debugMqtt(client, 'error');
    debugMqtt(client, 'end');

    return client;
};

class mqttHelper {
    constructor() {
        this.init();
    }

    init() {
        this._client = null;
        this._subscribes = {};
        this._basePath = '';
    }

    connect(credentials) {
        this.disconect();

        this._basePath = credentials.basePath;
        this._subscribes = {};

        this._client = connetMqtt(credentials);

        this._client.on('message', (topic, message, packet) => {
            dd(`message for ${topic}`);
            var objTopic1 = this.processTopic(topic);

            Object.entries(this._subscribes).forEach(([key, subscribe]) => {
                if (this.checkTopic(objTopic1, this.processTopic(key)))
                    subscribe.callbacks.forEach((callback) => callback(JSON.parse(message.toString()), packet));
            });
        });
    }

    reconnect(credentials) {
        let oldSubscribes = {};
        dd(this._subscribes);
        Object.keys(this._subscribes).forEach((key) => {
            let topic = key;
            if (key.startsWith(this._basePath)) topic = key.substring(this._basePath.length);
            oldSubscribes[credentials.basePath + topic] = this._subscribes[key];
        });
        this.connect(credentials);
        this._subscribes = oldSubscribes;
        Object.keys(this._subscribes).forEach((key) => this._client.subscribe(key));
    }

    disconect() {
        if (this._client) this._client.end();
        this.init();
    }

    isSubscribe(key) {
        return Object.keys(this._subscribes).includes(`${this._basePath}get/${key}`);
    }

    publish(key, msg) {
        key = `${this._basePath}set/${key}`;
        dd(`publish ${key}`);
        this._client.publish(key, JSON.stringify(msg));
    }

    subscribe(key, callback) {
        key = `${this._basePath}get/${key}`;

        if (!this._subscribes[key]) {
            dd(`subscribe: ${key}`);
            if (this._client) this._client.subscribe(key);
            this._subscribes[key] = { callbacks: [] };
        } else dd(`fakesubscribe: ${key}`);

        this._subscribes[key].callbacks.push(callback);
    }

    unsubscribe(key) {
        key = `${this._basePath}get/${key}`;

        if (this._subscribes[key] && this._subscribes[key].callbacks) {
            dd(`unsubscribe: ${key}`);
            if (this._client) this._client.unsubscribe(key);
            delete this._subscribes[key];
            /*const index = this._subscribes[key].callbacks.indexOf(callback);
            if (index > -1) this._subscribes[key].callbacks.splice(index, 1);

            if (this._subscribes[key].callbacks.length === 0) {
                dd(`unsubscribe: ${key}`);
                if (this._client) this._client.unsubscribe(key);
                delete this._subscribes[key];
            } else dd(`fakeunsubscribe: ${key}`);*/
        }
    }

    checkTopic(objTopic1, objTopic2) {
        var complete1 = `${objTopic1.device}/${objTopic1.property}`;
        var complete2 = `${objTopic2.device}/${objTopic2.property}`;
        return complete1 == complete2 || (objTopic1.device == objTopic2.device && objTopic2.property == '#');
    }

    processTopic(topic) {
        var sharp = topic.split('/');
        return {
            env: sharp[0],
            version: sharp[1],
            method: sharp[2],
            type: sharp[3],
            device: sharp[4],
            property: sharp.slice(5).join('/'),
        };
    }
}

export default mqttHelper;
